import * as React from "react"
import PropTypes from "prop-types"
import HeroScrollPcDemoDesktop from "./HeroScrollPcDemoDesktop"
import HeroScrollCaseDemoMobile from "./HeroScrollCaseDemoMobile"
import HeroScrollCaseDemoDesktopMobileMobileWrapper from "./HeroScrollCaseDemoDesktopMobileMobileWrapper"
import HeroScrollCaseDemoMobileContainer from "./HeroScrollCaseDemoMobileContainer"
import HeroScrollCaseDemoSecondMobileContainer from "./HeroScrollCaseDemoSecondMobileContainer"
import Image from "../Image"

const HeroScrollDemoContent = ({ type, imageDesktop, imageMobile }) => (
  <>
    {imageDesktop && (type === "Desktop" || type === "Desktop-mobile") && (
      <>
        <HeroScrollPcDemoDesktop>
          <Image itemprop="image" {...imageDesktop} />
        </HeroScrollPcDemoDesktop>
        {imageMobile && type === "Desktop-mobile" && (
          <HeroScrollCaseDemoDesktopMobileMobileWrapper>
            <HeroScrollCaseDemoMobile>
              <Image {...imageMobile} />
            </HeroScrollCaseDemoMobile>
          </HeroScrollCaseDemoDesktopMobileMobileWrapper>
        )}
      </>
    )}
    {imageMobile && (type === "Mobile" || type === "Mobile-mobile") && (
      <HeroScrollCaseDemoMobileContainer isDoubleMobile={type === "Mobile-mobile"}>
        <>
          {type === "Mobile-mobile" && (
            <HeroScrollCaseDemoSecondMobileContainer>
              <HeroScrollCaseDemoMobile>
                <Image {...imageMobile} objectFit="cover" />
              </HeroScrollCaseDemoMobile>
            </HeroScrollCaseDemoSecondMobileContainer>
          )}
          <HeroScrollCaseDemoMobile style={{ zIndex: 1 }}>
            <Image {...imageMobile} />
          </HeroScrollCaseDemoMobile>
        </>
      </HeroScrollCaseDemoMobileContainer>
    )}
  </>
)

HeroScrollDemoContent.propTypes = {
  type: PropTypes.string.isRequired,
  imageDesktop: PropTypes.string.isRequired,
  imageMobile: PropTypes.string.isRequired,
}

export default HeroScrollDemoContent
